import { render, staticRenderFns } from "./m-modal-newsletter.vue?vue&type=template&id=880972f6&scoped=true&"
import script from "./m-modal-newsletter.vue?vue&type=script&lang=js&"
export * from "./m-modal-newsletter.vue?vue&type=script&lang=js&"
import style0 from "./m-modal-newsletter.vue?vue&type=style&index=0&id=880972f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "880972f6",
  null
  
)

export default component.exports